import React, { useState } from "react";
import { BrowserPopup } from "../BrowserPopup";

export const QuestionnairePageBrowserPopupPanel = ({
	text,
	caption,
	hasBorder,
	isCentered,
	hasBackground,
	classes,
	url,
}) => {
	const [display, setDisplay] = useState(false);

	const showPopup = () => {
		if (!url) {
			return;
		}

		setDisplay(true);
	};

	const closePopup = () => {
		setDisplay(false);
	};

	let cls = classes || "rounded-xl";

	if (hasBorder) {
		cls += " border border-gray-400 rounded-lg py-2";
	}

	if (hasBackground) {
		cls += " bg-gray-100";
	}

	cls += isCentered === false ? " text-left" : " text-center";

	return (
		<>
			<div className={`mt-4 sm:mt-4 px-4 sm:px-4 ${cls}`} onClick={showPopup}>
				{text.map((string, i) => (
					<p
						key={`${i}_text`}
						className={"px-3 py-1"}
						dangerouslySetInnerHTML={{ __html: string }}
					></p>
				))}
				{url && (
					<div
						key={`url_${url}`}
						className={`pb-3 text-blue-600 cursor-pointer`}
					>
						<span
							className={`px-2 text-xs sm: text-sm bg-blue-800 border-blue-400 text-white rounded`}
						>
							Click to visit
						</span>
					</div>
				)}
			</div>
			<BrowserPopup
				title={caption}
				url={url}
				show={display}
				onClose={closePopup}
			/>
		</>
	);
};
